import Agent, { HttpsAgent } from 'agentkeepalive';

const maxSockets = process.env.NEXT_PUBLIC_CONNECTION_POOL_MAX_SOCKET
  ? Number(process.env.NEXT_PUBLIC_CONNECTION_POOL_MAX_SOCKET)
  : 600;
const maxFreeSockets = process.env.NEXT_PUBLIC_CONNECTION_POOL_MAX_FREE_SOCKET
  ? Number(process.env.NEXT_PUBLIC_CONNECTION_POOL_MAX_FREE_SOCKET)
  : 50;
const timeout = process.env.NEXT_PUBLIC_CONNECTION_POOL_TIMEOUT
  ? Number(process.env.NEXT_PUBLIC_CONNECTION_POOL_TIMEOUT)
  : 20000;
const freeSocketTimeout = process.env.NEXT_PUBLIC_CONNECTION_POOL_FREE_SCOKET_TIMEOUT
  ? Number(process.env.NEXT_PUBLIC_CONNECTION_POOL_FREE_SCOKET_TIMEOUT)
  : 20000;

export const httpKeepAliveAgent = new Agent({
  keepAlive: true,
  maxSockets: maxSockets,
  maxFreeSockets: maxFreeSockets,
  timeout: timeout,
  freeSocketTimeout: freeSocketTimeout,
});

export const httpsKeepAliveAgent = new HttpsAgent({
  keepAlive: true,
  maxSockets: maxSockets,
  maxFreeSockets: maxFreeSockets,
  timeout: timeout,
  freeSocketTimeout: freeSocketTimeout,
});
